<template>
  <div>
    <div class="bg-bg-contractor text-white px-3 rounded text-white mx-2 leading-relaxed whitespace-no-wrap">
      {{ contractor.title }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Contractor",
  props: ['contractor']
}
</script>